var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhipa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2004_675",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4999,
    cy: 12.5,
    r: 11.9999,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2004_675)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.4999,
    cy: 12.5,
    r: 11.9999,
    fill: "#ABBBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3912 14.9678L19.121 12.1013L17.9063 11.808L18.504 9.65253L16.3458 10.2474L16.0497 9.0355L14.2733 11.0803L14.9291 7.24529L13.6729 7.89275L12.3724 5.62109L11.0692 7.88999L9.81301 7.24252L10.4688 11.0775L8.6924 9.03273L8.39634 10.2447L6.23812 9.64976L6.83578 11.8052L5.62109 12.0985L9.35093 14.9651L8.94696 16.4177L12.1262 16.0663L12.0487 18.9578L12.3697 19.121L12.6906 18.9578L12.6132 16.0663L15.7924 16.4177L15.3884 14.9651L15.3912 14.9678Z",
    fill: "#F6F7FE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhipa);
export default __webpack_public_path__ + "static/media/phipa.031f1e8c7b80176a49a935bcbf79382d.svg";
export { ForwardRef as ReactComponent };